import { NoteType } from "../types/note-type";

export class Note {
  "created_at": string;
  "description": string;
  "horse": Horse;
  "horse_id": number;
  "id": number;
  "date": string;
  "title": string;
  "type": string;
  "updated_at": string;
  "user": User;
  "user_id": number;
  "weight": any;
  "src": any;
  "srcs": any[];
  "images": Array<any>;

  constructor(hasSign: boolean = false) {
    this.type = !!hasSign ? NoteType.sign : NoteType.other;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/classes/note.ts